
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalVarsService {
  private variables: Record<string, string> = {};

  set(key: string, value: string) {
    this.variables[key] = value;
  }

  get(key: string): string | undefined {
    return this.variables[key];
  }

  getAll(): Record<string, string> {
    return { ...this.variables };
  }

  clear(key?: string) {
    if (key) {
      delete this.variables[key];
    } else {
      this.variables = {};
    }
  }
}
